import { SettlementsOrAdvancesPage } from "./agtechSettlementsOrAdvances/SettlementsOrAdvancesPage";
import { useListAgtechSettlements } from "@/lib/api/agtech/ticketsExpanded";

export function AgtechSettlementsPage() {
  return <SettlementsOrAdvancesPage type="settlements" useListHook={useListAgtechSettlements} />;
}
